import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './index.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Das Wurzelelement #root fehlt in index.html.');
}

// Service worker registration lives in usePwa, which resolves the correct
// base path — it is deliberately not duplicated here.
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
